import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";

export class GameAudio extends NolimitSlotAudio {
    public init(): Promise<any> {
        return super.init().then(() => {
            return new Promise((resolve, reject) => {
                const isMobile: boolean = NolimitSlotAudio.apiPlugIn.options.device === "mobile";
                if (isMobile && this.isFirstOpened) {
                    this.toggleMute();
                }
                resolve(this);
            });
        })
    }
}